import Vue from 'vue';
import i18n from "../../../i18n";

export default {
  async createActivityType({ dispatch, commit }, payload) {
    return Vue.axios.post(Vue.$url("activity-type"), payload)
      .then((rsp) => {
        Vue.$log.debug("actvity type created and saved under", rsp.data.id);
        commit('mShowInfoMessage', i18n.t('common.saved', { 0: 'ActivityType', 1: payload.description }), { root: true });
        dispatch('fetchActivityTypes')
      })
  },

  async fetchNextMaxCode({ commit }) {
    return Vue.axios.get(Vue.$url("activity-type/max-code"))
      .then((rsp) => {
        commit('SET_NEXT_SEQ_CODE', rsp.data)
        return rsp.data;
      })
  },

  async fetchActivityTypes({ commit }) {
    return Vue.axios.get(Vue.$url("activity-type"))
      .then((rsp) => {
        commit("SET_ACTIVITY_TYPES", rsp.data);
      })
  },

  async deleteActivityType({ dispatch, commit }, payload) {
    Vue.$log.debug('trying to delete activity type', payload.id);
    return Vue.axios.delete(Vue.$url("activity-type/" + payload.id))
      .then(() => {
        dispatch('fetchActivityTypes')
        commit('mShowInfoMessage', i18n.t('common.lockupdate', { 0: payload.description }), { root: true });
      });
  },

  async updateActivityType({ dispatch, commit }, payload) {
    return Vue.axios.put(Vue.$url("activity-type/" + payload.id), payload)
      .then(() => {
        dispatch('fetchActivityTypes')
        commit('mShowInfoMessage', i18n.t('common.updated', { 0: 'ActivityType', 1: payload.description }), { root: true });
      })
  },
}